// extracted by mini-css-extract-plugin
export default {"root":"QlVPgZym","hidden":"YMl6tuqD","capsule":"uRWtrXy3","dragging":"FveozcMO","button":"A4iuMrwm","active":"lTI19L4Y","label":"Hzc2OPCD","icon":"Q6nK70OA"};